export const MEETING_ACCESS_DENIED = 100
export const MEETING_TOO_EARLY = 101
export const MEETING_FINISHED = 102
